import { getSessionKey } from 'storage/sessionKey'

export const getAuthorizationSessionHeader = (): string | undefined => {
    const sessionKey = getSessionKey()

    if (!sessionKey) {
        return
    }

    // eslint-disable-next-line consistent-return
    return `Session ${sessionKey}`
}
